export const CATALOG_UPLOAD_ACCEPT = '.xlsx,.xls,.csv';

const CATALOG_FILE_EXTENSIONS = ['.xlsx', '.xls', '.csv'] as const;

export const isCatalogSpreadsheet = (file: File) => {
  const name = file.name.toLowerCase();
  return CATALOG_FILE_EXTENSIONS.some((extension) => name.endsWith(extension));
};

export const getCatalogFileKind = (file: File) => {
  const name = file.name.toLowerCase();
  const extension = CATALOG_FILE_EXTENSIONS.find((item) => name.endsWith(item));
  return extension ? extension.slice(1).toUpperCase() : 'FILE';
};

/** Pulls the human-readable text from responses like: 400 BAD_REQUEST "This store can't upload..." */
export const extractCatalogUploadErrorMessage = (raw?: string) => {
  if (!raw?.trim()) {
    return '';
  }

  const quoted = raw.match(/"([^"]+)"/);
  if (quoted?.[1]) {
    return quoted[1].trim();
  }

  return raw.replace(/^\d{3}\s+[A-Z_]+\s+/, '').trim();
};
